import _ from 'lodash'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'
import queryString from 'query-string'

import * as classifiedActions from 'reduxBits/classified/actions'
import * as searchParamsActions from 'reduxBits/searchParams/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { searchParameters, globalData } from 'tracking/dataCollectors'

import { getTreeNodes } from 'utils/parameters'

const createDataLayerObject = (state, localData = {}) => {
  let objectId = _.toString(_.slice(_.split(_.get(state, 'router.location.pathname', ''), '/'), 2))
  if (_.isEmpty(objectId)) {
    objectId = 'overview'
  } else {
    const modalQuery = _.get(state, 'router.location.state.searchModal.query')
    if (!_.isEmpty(modalQuery)) {
      const masterKey = _.get(_.keys(modalQuery), '0')
      const searchParams = state.searchParams.byQueryKey
      const something = _.get(searchParams, masterKey)
      const thing = getTreeNodes(something, modalQuery)
      objectId = _.reduce(
        thing,
        (result, value, key) => {
          if (key === 0) return result
          result = `${result}/${value.label}` // eslint-disable-line no-param-reassign
          return result
        },
        objectId,
      )
    }
  }

  return renderDataLayerObject({
    ...gtm.clearDataLayerParameters(),
    ...globalData(state),
    ...{
      event: 'view',
      eventType: 'View',
      objectId,
      objectName: 'Filter',
      objectType: 'Page',
      domain: 'adout',
      subDomain: 'filter',
      objectFilterSearchNumResult: _.get(
        state,
        'classified.searchResultCountPreview.searchTotal',
        0,
      ),
      origin: {
        id: objectId,
        type: 'Page',
        url: encodeURI(window.location.href),
      },
    },
    ...searchParameters(
      _.get(state, 'searchParams'),
      queryString.parse(_.get(state, 'router.location.search')),
    ),
    ...localData,
  })
}

export const filterDefault = {
  validators: [
    validators.redux('@@router/LOCATION_CHANGE', (action) =>
      _.get(action, 'payload.location.pathname', '').startsWith('/filter'),
    ),
    validators.redux(classifiedActions.RECEIVE_SEARCH_TOTAL, (action) => action.type),
  ],
  events: [gtm.event(({ state }) => createDataLayerObject(state, {}, 'default'))],
}

export const filterNoUpdate = {
  validators: [
    validators.redux('@@router/LOCATION_CHANGE', (action) =>
      _.get(action, 'payload.location.pathname', '').startsWith('/filter'),
    ),
    validators.redux(searchParamsActions.NO_UPDATE_PARAMETERS, (action) => action.type),
  ],
  events: [gtm.event(({ state }) => createDataLayerObject(state, {}, 'noupdate'))],
}
